<script setup lang="ts">
import { CREDIT_HERO_STATS, CREDIT_PARTNERS } from '../content';
</script>

<template>
	<section class="bg-black px-5 py-16 text-[#FAFAFA] lg:px-6 lg:py-18">
		<div class="mx-auto flex max-w-[1240px] flex-col gap-9 lg:gap-14">
			<dl class="m-0 flex flex-col lg:flex-row">
				<div
					v-for="(stat, index) in CREDIT_HERO_STATS"
					:key="stat.value"
					:class="[
						'flex flex-col gap-5 border-b border-[#2A2A2A] lg:gap-9 lg:border-b-0',
						index === 0
							? 'pb-7 lg:w-[417px] lg:pr-14 lg:pb-0'
							: 'pt-12 pb-7 lg:border-l lg:py-0 lg:pl-14'
					]"
				>
					<dt
						class="order-2 text-[14px] leading-[1.45] text-[#A3A3A3] lg:text-[16px]"
					>
						{{ stat.label }}
					</dt>
					<dd
						class="order-1 m-0 font-[Inter,sans-serif] text-[clamp(44px,4.4vw,64px)] leading-none font-light tracking-[-0.02em] whitespace-nowrap"
					>
						{{ stat.value }}
					</dd>
				</div>
			</dl>
			<div class="flex flex-col gap-8 lg:flex-row lg:items-center lg:gap-0">
				<p
					class="m-0 max-w-[260px] text-[14px] leading-[1.5] text-[#A3A3A3] lg:w-[288px] lg:max-w-none lg:flex-none lg:pr-10"
				>
					Comparamos propostas de bancos e administradoras parceiras
				</p>
				<ul
					class="-mr-5 m-0 flex flex-1 list-none overflow-x-auto border-y border-[#2A2A2A] p-0 [scrollbar-width:none] lg:mr-0 lg:grid lg:grid-cols-5 lg:overflow-visible"
				>
					<li
						v-for="partner in CREDIT_PARTNERS"
						:key="partner"
						class="flex h-[70px] w-32 flex-none items-center justify-center border-r border-[#2A2A2A] text-[18px] text-[#FAFAFA] last:border-r-0 lg:h-[92px] lg:w-auto lg:text-[22px]"
					>
						{{ partner }}
					</li>
				</ul>
			</div>
		</div>
	</section>
</template>
